/**
 * Meta Pixel configuration (#2442).
 *
 * The pixel id comes from the build-time env (`REACT_APP_META_PIXEL_ID`, read
 * once in `ux/src/config.js`, set on the DigitalOcean web component). Unset,
 * or anything but digits, means the pixel is off: no script, no `window.fbq`,
 * no network, no errors. Read it only through `getMetaPixelId()`.
 *
 * The Conversions API access token is server-only (`META_CAPI_ACCESS_TOKEN`,
 * backend/services/adConversions/) and never reaches this bundle.
 */

import config from '../config';

export const META_PIXEL_SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

/** Meta standard events fired from the web app. */
export const META_EVENTS = {
  PAGE_VIEW: 'PageView',
  COMPLETE_REGISTRATION: 'CompleteRegistration',
  PURCHASE: 'Purchase',
};

const PIXEL_ID_RE = /^\d+$/;

/** @returns {string} the pixel id, or '' when the integration is off */
export function getMetaPixelId() {
  const raw = config.META_PIXEL_ID;
  const id = typeof raw === 'string' ? raw.trim() : '';
  return PIXEL_ID_RE.test(id) ? id : '';
}

export function isMetaPixelConfigured() {
  return getMetaPixelId() !== '';
}
